import { createContext, useContext } from 'react';

import type { LeafletMapContext } from './LeafletMap';

const LeafletContext = createContext<LeafletMapContext | undefined>(undefined);

export const LeafletProvider = LeafletContext.Provider;

export function useLeafletMapContext() {
  const context = useContext(LeafletContext);
  if (context === undefined) {
    throw new Error('Context must be used within a Leaflet Provider');
  }
  return context;
}
